import type { AttachmentView } from '@components/files/AttachmentGallery';

type FileRowLike = {
  id?: string;
  filename?: string;
  contentType?: string;
  sizeBytes?: number | string | null;
  width?: number | string | null;
  height?: number | string | null;
  uploadedByUserId?: string | null;
};

export function fileRowToView(row: FileRowLike): AttachmentView | null {
  if (!row.id || !row.filename || !row.contentType) {
    return null;
  }
  return {
    id: row.id,
    url: `/api/files/${encodeURIComponent(row.id)}`,
    filename: row.filename,
    contentType: row.contentType,
    sizeBytes: row.sizeBytes == null ? null : Number(row.sizeBytes),
    width: row.width == null ? null : Number(row.width),
    height: row.height == null ? null : Number(row.height),
    uploadedByUserId: row.uploadedByUserId ?? null
  };
}

export function fileRowsToViews(rows: unknown): AttachmentView[] {
  if (!Array.isArray(rows)) {
    return [];
  }
  const views: AttachmentView[] = [];
  for (const row of rows) {
    if (!row || typeof row !== 'object') {
      continue;
    }
    const view = fileRowToView(row as FileRowLike);
    if (view) {
      views.push(view);
    }
  }
  return views;
}
